const metrics = (state) => state.metrics;
const metric = (state) => state.metric;

export default {
  metrics,
  metric,
};
